export enum ApiMethodClaimObjectAdditionCodeEnum {
    Automatic = 'AFLE',
    Manually = 'HAND',
}
